import { NgClass } from '@angular/common'
import { ChangeDetectionStrategy, Component, input } from '@angular/core'

@Component({
  selector: 'coins-tag',
  imports: [NgClass],
  templateUrl: './coins-tag.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CoinsTagComponent {
  color = input<string>('text-blue-400')
  points = input<string | number>()
  background = input<string>('bg-blue-primary-strong')
}
